export default __webpack_public_path__ + "static/media/Bird2.2b922d95.png";